// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__32d7n","paramInput":"JobSimulator_paramInput__V3Y5L","input":"JobSimulator_input__2pheC"};